<template>
  <path
    id="ic_supervisor_account_24px"
    d="M19.4,13.4a3,3,0,1,0-3-3A2.991,2.991,0,0,0,19.4,13.4Zm-9-1.2A3.6,3.6,0,1,0,6.8,8.6,3.585,3.585,0,0,0,10.4,12.2Zm9,3.6c-2.2,0-6.6,1.1-6.6,3.3v2.7H26V19.1C26,16.9,21.6,15.8,19.4,15.8Zm-9-1.2C7.6,14.6,2,16,2,18.8v3h8.4V19.1c0-1.02.4-2.808,2.844-4.164A14.74,14.74,0,0,0,10.4,14.6Z"
    transform="translate(-2 -5)" />
</template>
